import qs from 'qs';
import omit from 'lodash/omit';
import forEach from 'lodash/forEach';

const getParams = () => {
    const params = qs.parse(window.location.search.replace(/\?/, ''));
    return params;
};

/**
 * 从 url 获取参数，可通过制定 excludes 参数设置排除项
 * @param {*} param
 */
export const getViewParams = ({ excludes = [] } = {}) => {
    const queryObj = getParams();

    const splitedHash = window.location.hash.split('/');
    const hasValidHash = splitedHash[1];

    // 没有 hash 就用参数里的
    const patentId = hasValidHash ? splitedHash[1] : queryObj.patentId || queryObj.related_id;

    const viewParams = Object.assign(queryObj, {
        hasValidHash,
        patentId
    });

    viewParams.page = (() => {
        const cacheKey = `listOnPage:${patentId}`;
        const cachePage = sessionStorage.getItem(cacheKey);
        const viewParamPage = viewParams.page;

        let page;

        if (queryObj.patentId === queryObj.related_id) {
            page = viewParamPage || cachePage;
        } else {
            page = cachePage || viewParamPage;
        }
        return parseInt(page);
    })();

    if (isNaN(viewParams.page)) {
        delete viewParams.page;
    }

    if (excludes.length === 0) {
        return viewParams;
    }

    return omit(viewParams, excludes);
};

export function getViewParamsByRoute (route, { omits = [], trans = [] } = {}) {
    const viewParams = { ...route.query };
    const patentId = route.query.patentId || route.query.related_id;

    viewParams.isSingleView = !route.params.right;
    viewParams.isCompareView = !!(route.params.rightId && route.params.leftId);
    if (viewParams.isCompareView) {
        viewParams.rightPatentId = route.params.rightId;
        viewParams.leftPatentId = route.params.leftId;
    }
    viewParams.neighborhoodsNames = {
        left: route.params.left,
        right: route.params.right,
    };

    viewParams.page = (() => {
        const cacheKey = `listOnPage:${patentId}`;
        const cachePage = sessionStorage.getItem(cacheKey);
        const viewParamPage = viewParams.page;

        let page;

        if (route.query.patentId === route.query.related_id) {
            page = viewParamPage || cachePage;
        } else {
            page = cachePage || viewParamPage;
        }
        return parseInt(page);
    })();

    if (isNaN(viewParams.page)) {
        delete viewParams.page;
    }

    if (trans && trans.length) {
        forEach(trans, ({ transFrom, transTo, deleteOrigin, forceUpdate }) => {
            if (!forceUpdate && viewParams[transTo]) return;
            viewParams[transTo] = viewParams[transFrom];
            if (deleteOrigin) {
                delete viewParams[transFrom];
            }
        });
    }

    return omit(viewParams, omits);
}

export function defaultViewPropsGetter(route) {
    const viewParams = getViewParamsByRoute(route);
    return { viewParams };
}

export default getParams;
